import {
    ABSOLUTE_HTTP_HREF_PATTERN,
    DIRECT_LINK_DISPLAY_ADDRESS_ELLIPSIS,
    DIRECT_LINK_DISPLAY_ADDRESS_MAX_LENGTH,
    SOLE_WEBSITE_URL_PATTERN,
} from "../../onboardingAgentConstants";

/** Extra text alongside the link is intentionally treated as a normal question, not a direct link. */
export const extractSoleWebsiteDomain = (message: string): string | null => {
    const match = SOLE_WEBSITE_URL_PATTERN.exec(message.trim());

    return match ? match[1].toLowerCase() : null;
};

export const truncateDirectLinkAddress = (address: string): string =>
    address.length > DIRECT_LINK_DISPLAY_ADDRESS_MAX_LENGTH
        ? `${address.slice(0, DIRECT_LINK_DISPLAY_ADDRESS_MAX_LENGTH)}${DIRECT_LINK_DISPLAY_ADDRESS_ELLIPSIS}`
        : address;

/** A protocol-less address (e.g. "similarweb.com") isn't treated as an absolute link, so it wouldn't open in a new tab. */
export const buildDirectLinkHref = (address: string): string =>
    ABSOLUTE_HTTP_HREF_PATTERN.test(address) ? address : `https://${address}`;
